
<div class="container-fluid p-0">
  <button class="btn btn-primary expand-btn" (click)="expand()">
    <mat-icon>open_in_full</mat-icon>
  </button>
  <ng-container *ngTemplateOutlet="textArea"></ng-container>
</div>

<ng-template #textArea>
  <ng-container *ngIf="jargonLoadingState; else noLoadingState">
    <textarea class="form-control expand-scrollbar"
              [rows]="rows"
              [placeholder]="placeholder"
              [(ngModel)]="value"
              [disabled]="disabled"
              [jargonLoadingState]="jargonLoadingState">
    </textarea>
  </ng-container>
  <ng-template #noLoadingState>
    <textarea class="form-control expand-scrollbar"
              [rows]="rows"
              [placeholder]="placeholder"
              [(ngModel)]="value"
              [disabled]="disabled">
    </textarea>
  </ng-template>
</ng-template>

<ng-template #expandedModalTml let-expandModal>
	<div class="modal-header">
		<h4 class="modal-title" *ngIf="title">{{ title }}</h4>
		<button type="button" class="btn btn-sm btn-primary" (click)="expandModal.dismiss()">
      <mat-icon>close</mat-icon>
    </button>
	</div>
	<div class="modal-body">
		<ng-container *ngTemplateOutlet="textArea"></ng-container>
	</div>
	<div class="modal-footer">
		<button type="button" class="btn btn-outline-primary" (click)="save()">Save</button>
	</div>
</ng-template>
